import * as i0 from "@angular/core";
/**
 * Check whether a section contains selected item(s)
 *
 * value: A composite object of booleans organized by category, section, menu, and metric ids, marking which metrics
 *   have been selected.
 *
 * Params:
 *   categoryLabel: The label of a metric category; this is the broadest way metrics are grouped.
 *   sectionLabel: The label of a metric section; this is part of a category and can contain individual metrics or
 *     submenus of individual metrics.
 *   menuLabel: The label of a metric menu, if the metric is part of a submenu; not all metrics are part of submenus.
 *
 */
export class IsSectionItemSelected {
    transform(value, categoryLabel, sectionLabel) {
        const section = value[categoryLabel][sectionLabel];
        return Object.values(section).some((itemSelected) => itemSelected);
    }
}
IsSectionItemSelected.ɵfac = function IsSectionItemSelected_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || IsSectionItemSelected)(); };
IsSectionItemSelected.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "isSectionItemSelected", type: IsSectionItemSelected, pure: true, standalone: false });
